import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { EuiDialogComponent } from './eui-dialog.component';
import { EuiDialogService } from './services/eui-dialog.service';
import { EuiDynamicComponentService } from '../../services/eui-dynamic-component.service';
import { EuiIconModule } from '../atoms';
import { EuiButtonModule } from '../eui-button/eui-button.component';

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        TranslateModule,
        A11yModule,
        EuiIconModule,
        MatDialogModule,
        EuiButtonModule,
        DragDropModule,
    ],
    declarations: [
        EuiDialogComponent,
    ],
    exports: [
        EuiDialogComponent,
    ],
    providers: [
        EuiDialogService,
        EuiDynamicComponentService,
    ],
    entryComponents: [
        EuiDialogComponent,
    ],
})
export class EuiDialogModule { }
